import { $authHost } from "../../http";
import { 
    AN_OBJECT_SECTION_GET_REQUEST, AN_OBJECT_SECTION_GET_SUCCESS, AN_OBJECT_SECTION_GET_ERROR, 
    AN_OBJECT_SECTION_GET_BY_KEY_REQUEST, AN_OBJECT_SECTION_GET_BY_KEY_SUCCESS, AN_OBJECT_SECTION_GET_BY_KEY_ERROR, 
    AN_OBJECT_SECTION_ADD_REQUEST, AN_OBJECT_SECTION_ADD_SUCCESS, AN_OBJECT_SECTION_ADD_ERROR, 
    AN_OBJECT_SECTION_EDIT_REQUEST, AN_OBJECT_SECTION_EDIT_SUCCESS, AN_OBJECT_SECTION_EDIT_ERROR, 
    AN_OBJECT_SECTION_DELETE_REQUEST, AN_OBJECT_SECTION_DELETE_SUCCESS, AN_OBJECT_SECTION_DELETE_ERROR
} from "../constants/anObjectSectionConstants";

export const getAnObjectSections = (args) => async (dispatch) => {
    try {
        dispatch({
            type: AN_OBJECT_SECTION_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/anObjectSection/query",
            args || {},
            config,
        );
        dispatch({
            type: AN_OBJECT_SECTION_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: AN_OBJECT_SECTION_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getAnObjectSectionByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: AN_OBJECT_SECTION_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/anObjectSection/${id}`,
        );
        dispatch({
            type: AN_OBJECT_SECTION_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: AN_OBJECT_SECTION_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addAnObjectSection = ({ name, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: AN_OBJECT_SECTION_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/anObjectSection",
            { name, description },
            config,
        );
        dispatch(getAnObjectSections(queryArgs || {}));
        dispatch({
            type: AN_OBJECT_SECTION_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: AN_OBJECT_SECTION_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editAnObjectSection = ({ id, name, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: AN_OBJECT_SECTION_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/anObjectSection",
            { id, name, description },
            config,
        );
        dispatch(getAnObjectSections(queryArgs || {}));
        dispatch({
            type: AN_OBJECT_SECTION_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: AN_OBJECT_SECTION_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteAnObjectSection = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: AN_OBJECT_SECTION_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/anObjectSection",
            { data: { id } },
            config,
        );
        dispatch(getAnObjectSections(queryArgs || {}));
        dispatch({
            type: AN_OBJECT_SECTION_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: AN_OBJECT_SECTION_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

